import { Alert } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'

type DeleteAccountApiErrorAlertProps = {
  className?: string
}
export function DeleteAccountApiErrorAlert ({
  className
}: DeleteAccountApiErrorAlertProps) {
  const { t } = useTranslation('deleteAccount')

  return (
    <Alert variation="error" className={className}>
      {t('errors.unableToDelete')}
    </Alert>
  )
}

export default DeleteAccountApiErrorAlert
